import type { participation as en } from '@/i18n/locales/en/participation';
import type { Translation } from '@/i18n/types';

export const participation: Translation<typeof en> = {
  page: {
    title: 'Katılım',
    lead: 'Etkileşim hunisi: davet edilmekten yapısal olarak aktif olmaya, artı günlük etkileşim oranları.',
    noScope: 'Katılım rakamlarını görmek için bir şirket seçin.',
    noDepartments: 'Buradaki hiçbir departmanın görebileceğiniz istatistiği yok.',
    disclaimer:
      'Tüm veriler gösterge niteliğinde iyi oluş bilgileridir ve tıbbi teşhis niteliği taşımaz. Eğilimler yalnızca yeterli sayıda katılımcı olduğunda gösterilir (tasarım gereği gizlilik).',
  },
  filters: {
    department: {
      label: 'Departman',
    },
    location: {
      label: 'Konum',
      all: 'Tüm konumlar',
    },
  },
  funnel: {
    title: 'Etkileşim hunisi',
    pctOfPrevious: "önceki adımın %{{pct}}'i",
    steps: {
      invited: 'Davet edildi',
      activated: 'Etkinleştirildi',
      active_7d: 'Aktif (7g)',
      active_30d: 'Aktif (30g)',
      structurally_active: 'Yapısal olarak aktif',
      needs_reactivation: 'Yeniden etkinleştirme gerekiyor',
    },
  },
  rates: {
    title: 'Etkileşim oranları',
    keys: {
      daily_sync_pct: 'Günlük senkronizasyon',
      ai_coach_use_pct: 'Yapay zeka koçu kullanımı',
      challenge_participation_pct: 'Meydan okuma katılımı',
      notification_open_pct: 'Bildirim açılışları',
      break_adoption_pct: 'Ara benimseme',
      focus_rhythm_pct: 'Odak ritmi',
    },
  },
  breakdown: {
    department: 'Departmana göre',
    location: 'Konuma göre',
    pilotGroup: 'Pilot gruba göre',
    empty: 'Ayrıştırılacak veri yok.',
    pilotGroupEmpty: 'Henüz hiçbir pilot bu departmanı kapsamıyor.',
    ratio: '{{activated}}/{{invited}} · %{{pct}}',
    shielded: {
      badge: 'Gizlenmiş',
      message:
        'Gizliliği koruyan bir görünüm için yeterli katılımcı yok ({{invited}}) — en az {{min}} gerekli.',
    },
    columns: {
      name: 'İsim',
      invited: 'Davet edildi',
      activated: 'Etkinleştirildi',
      active30d: 'Aktif (30g)',
    },
  },
  status: {
    noData: '—',
  },
};
